<template>
  <div class="mobile-modal-overlay bg-[rgba(0,0,0,0.6)] fixed inset-0 z-2000 flex items-end justify-center" @click.self="$emit('close')">
    <div class="mobile-modal-sheet rounded-2xl bg-white w-full max-w-md mx-auto p-6 shadow-lg">
      <div class="text-center text-[#1A1A1A] text-xl font-bold mb-6">
        Are you sure you want to leave?
      </div>
      <div class="flex flex-col sm:flex-row gap-4">
        <button
          @click="$emit('close')"
          class="flex-1 min-h-[56px] px-0 py-0 border-2 border-[#0033A0] text-[#0033A0] font-bold rounded-2xl text-lg hover:bg-[rgba(0,51,160,0.05)] transition-colors duration-150"
        >
          Cancel
        </button>
        <button
          @click="$emit('exit')"
          class="flex-1 min-h-[56px] px-0 py-0 bg-[#0033A0] hover:bg-[#002580] text-white font-bold rounded-2xl text-lg shadow-sm transition-colors duration-150"
        >
          Leave Meeting
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineEmits(['close', 'exit'])
</script>

<style scoped>
.trava-logo {
  font-family: 'Zen Tokyo Zoo', sans-serif;
  letter-spacing: 0.1em;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
